import { request } from '@/plugins/http';

/**
 * 终端列表
 * @param params
 * @returns {AxiosPromise}
 */
const getDataTboxList = params => request('/tbox/getDataTboxList', params);

/**
 * 终端新增
 * @param params
 * @returns {AxiosPromise}
 */
const addDataTbox = params => request('/tbox/addDataTbox', params);

/**
 * 终端修改
 * @param params
 * @returns {AxiosPromise}
 */
const updateDataTbox = params => request('/tbox/updateDataTbox', params);

/**
 * 终端修改
 * @param params
 * @returns {AxiosPromise}
 */
const delDataTboxs = params => request('/tbox/delDataTboxs', params);

/**
 * 刷写查询接口
 * @param params
 * @returns {AxiosPromise}
 */
const getBoter = params => request('/tbox/getBoter', params);

/**
 * 刷写接口
 * @param params
 * @returns {AxiosPromise}
 */
const writeBoter = params => request('/tbox/writeBoter', params);

export {
    getDataTboxList,
    addDataTbox,
    updateDataTbox,
    delDataTboxs,
    getBoter,
    writeBoter
};
